import { Search } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';

import { UserBadge } from '@/domains/auth';

export function Header() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const urlSearchTerm = searchParams.get('search') ?? '';
  const [searchTerm, setSearchTerm] = useState(urlSearchTerm);

  useEffect(() => {
    setSearchTerm(urlSearchTerm);
  }, [urlSearchTerm]);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    const trimmed = value.trim();
    navigate(trimmed ? `/events?search=${encodeURIComponent(trimmed)}` : '/events', { replace: true });
  };

  const handleSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const trimmed = searchTerm.trim();
    navigate(trimmed ? `/events?search=${encodeURIComponent(trimmed)}` : '/events');
  };

  return (
    <header className="sticky top-0 z-20 flex h-16 items-center justify-between border-b border-header-border bg-header px-6 backdrop-blur-sm print:hidden">
      {/* Search */}
      <form onSubmit={handleSearchSubmit} className="flex w-full max-w-md items-center gap-2 rounded-lg border border-input bg-card px-3 py-2">
        <Search className="size-4 text-muted-foreground" />
        <input
          type="text"
          placeholder="Zoek evenementen op naam of zaaknummer..."
          className="w-full bg-transparent text-sm text-foreground outline-none placeholder:text-muted-foreground"
          value={searchTerm}
          onChange={handleSearchChange}
        />
      </form>

      <UserBadge />
    </header>
  );
}
